import { useBreakpoints } from '@monorepo/nova-ui';
import { useLocalStorage } from '@monorepo/react-hooks';
import { CartData, IsLoggedInKey } from '@monorepo/types';
import { NotificationsCenter } from '../../notifications-center';
import { CartButton } from './cart-button';
import { LanguageSelector } from './components';
import { DiscordButton } from './components/buttons/discord-button';
import { LogInButton } from './log-in-button';
import { MenuMobile } from './menu-mobile';
import { NewOrderButton } from './new-order-button';
import { ProfileMenu } from './profile-menu';
import {
  StyledHeaderMobile,
  StyledMobileLeftSection,
  StyledMobileRightSection,
} from './styles/layout-header-mobile.styled';
import { YoutubeLive } from './youtube-live';

/* For Tablet and Mobile */
const LayoutHeaderMobile = ({
  cartData,
  isTransparent,
  userId,
}: {
  cartData: CartData;
  isTransparent: boolean;
  userId?: string;
}) => {
  const { isMobile } = useBreakpoints();
  const { storedValue: isUserLoggedIn } = useLocalStorage(IsLoggedInKey, false);

  return (
    <StyledHeaderMobile
      className="header--mobile"
      isTransparent={isTransparent}
    >
      <StyledMobileLeftSection>
        <MenuMobile userId={userId} />
        {isMobile ? (
          <>
            <YoutubeLive />
            <DiscordButton />
          </>
        ) : (
          <>
            <DiscordButton />
            <YoutubeLive />
          </>
        )}
      </StyledMobileLeftSection>
      <StyledMobileRightSection>
        {isUserLoggedIn ? (
          <NewOrderButton cartData={cartData} />
        ) : (
          <LogInButton />
        )}
        {isUserLoggedIn && <CartButton cartData={cartData} />}
        {isUserLoggedIn && <NotificationsCenter />}
        <ProfileMenu userId={userId} />
        {!isMobile && <LanguageSelector />}
      </StyledMobileRightSection>
    </StyledHeaderMobile>
  );
};

export { LayoutHeaderMobile };
